import { GET } from "@/services/request";
import * as APIs from '@/services/APIs';
import { fetchGET } from "../fetch";
import _ from "lodash";

/**
 * 获取服务站点列表
 */
export const fetchServiceSiteList = async () => {
    const res = await GET(APIs.API_SERVICE_SITE_LIST);

    return res.data.data ?? {};
};

/**
 * 获取网站基础数据的两个二维码
 */
export const fetchSite = async () => {
    const res = await GET(APIs.API_SITE);

    return res.data.data ?? {};
};

/**
 * 获取全部城市数据
 */
export const fetchAllCities = async (village) => {
    const res = await fetchGET(APIs.API_CITY_GETCITIESALL, {
        params: { shopping_village: village },
    });

    return res.data.data ?? {};
};
